
export default function Closing() {
  return (
    <section className="closing-section py-24 bg-gradient-to-b from-gray-900 to-black text-white">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <div className="mb-12">
          <div className="w-20 h-20 bg-red-600 rounded-full flex items-center justify-center mx-auto mb-8">
            <i className="ri-alarm-warning-line text-4xl text-white"></i>
          </div>
          <h2 className="closing-heading text-4xl md:text-5xl font-bold mb-8" style={{ lineHeight: '1.5' }}>
            火災による「供給責任」を
            <br />
            果たせなくなる前に
          </h2>
          <p className="closing-subtext text-xl md:text-2xl text-gray-300 mb-12">
            今すぐ、リスク対策の穴を埋めてください。
          </p>
        </div>

        <div className="bg-white/10 backdrop-blur-sm rounded-3xl closing-inner-block p-10 mb-12">
          {/* PC表示用 */}
          <div className="closing-stats-grid-pc grid md:grid-cols-3 gap-8 mb-10">
            <div>
              <div className="text-4xl font-bold text-red-500 mb-2">即時復旧</div>
              <p className="text-sm text-gray-300">拭き取るだけで操業再開</p>
            </div>
            <div>
              <div className="text-4xl font-bold text-green-500 mb-2">資産保全</div>
              <p className="text-sm text-gray-300">機械を壊さない消火</p>
            </div>
            <div>
              <div className="text-4xl font-bold text-blue-500 mb-2">BCP対策</div>
              <p className="text-sm text-gray-300">事業継続を守る</p>
            </div>
          </div>

          {/* スマホ表示用 */}
          <div className="closing-stats-grid-mobile mb-8">
            <div className="mb-4">
              <div className="closing-stat-title text-4xl font-bold text-red-500 mb-1">即時復旧</div>
              <p className="text-xs text-gray-300">拭き取るだけで操業再開</p>
            </div>
            <div className="mb-4">
              <div className="closing-stat-title text-4xl font-bold text-green-500 mb-1">資産保全</div>
              <p className="text-xs text-gray-300">機械を壊さない消火</p>
            </div>
            <div>
              <div className="closing-stat-title text-4xl font-bold text-blue-500 mb-1">BCP対策</div>
              <p className="text-xs text-gray-300">事業継続を守る</p>
            </div>
          </div>

          <a
            href="https://fireout.stores.jp/inquiry"
            target="_blank"
            rel="noopener noreferrer"
            className="closing-cta-btn inline-block bg-red-600 text-white rounded-full font-bold hover:bg-red-700 transition-all transform hover:scale-105 shadow-2xl whitespace-nowrap cursor-pointer px-12 py-5 text-xl"
          >
            無料お見積もり・導入のご相談
          </a>
        </div>

        {/* 追伸エリア */}
        <div className="closing-postscript bg-gradient-to-r from-red-900/30 to-orange-900/30 rounded-2xl border border-red-500/30">
          <div className="flex items-start space-x-3">
            <div className="closing-ps-icon w-12 h-12 bg-red-600 rounded-full flex items-center justify-center flex-shrink-0">
              <i className="ri-mail-line text-2xl text-white"></i>
            </div>
            <div className="text-left">
              <p className="closing-ps-title font-bold mb-1">追伸</p>
              <p className="closing-ps-text text-gray-300 leading-relaxed">
                ボヤ騒ぎで数千万円のラインを止める前に。消火器の粉で機械を全損させる前に。
                <br />
                「汚さない消火」という選択肢を、今すぐ工場に導入してください。
              </p>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        .closing-stats-grid-pc { display: grid; }
        .closing-stats-grid-mobile { display: none; }

        @media (max-width: 768px) {
          /* 見出しを小さく */
          .closing-heading {
            font-size: 1.4rem !important;
            line-height: 1.5 !important;
            margin-bottom: 1rem !important;
          }
          .closing-subtext {
            font-size: 0.95rem !important;
            margin-bottom: 1.5rem !important;
          }

          /* 内側ブロックのパディング縮小 */
          .closing-inner-block {
            padding: 1.25rem !important;
            margin-bottom: 1.25rem !important;
          }

          /* 統計グリッド切り替え */
          .closing-stats-grid-pc { display: none !important; }
          .closing-stats-grid-mobile {
            display: flex;
            flex-direction: column;
            width: 100%;
            box-sizing: border-box;
          }
          .closing-stat-title {
            font-size: 1.75rem !important;
          }

          /* CTAボタン */
          .closing-cta-btn {
            width: 100% !important;
            display: block !important;
            padding: 0.65rem 0.75rem !important;
            font-size: 0.85rem !important;
            box-sizing: border-box;
          }

          /* 追伸エリア全体を小さく */
          .closing-postscript {
            padding: 0.75rem !important;
          }
          .closing-ps-icon {
            width: 2rem !important;
            height: 2rem !important;
            min-width: 2rem !important;
          }
          .closing-ps-icon i {
            font-size: 1rem !important;
          }
          .closing-ps-title {
            font-size: 0.85rem !important;
            margin-bottom: 0.25rem !important;
          }
          .closing-ps-text {
            font-size: 0.75rem !important;
            line-height: 1.5 !important;
          }
        }
      `}</style>
    </section>
  );
}
